import React, { useState, useEffect } from 'react';
import { Phone, MapPin, Clock, Instagram, Facebook, ChevronDown, Fish, Flame, Salad, Cake, Menu, X, Music, Truck, Navigation, Globe } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

// ========== OVDE MENJATE SLIKE ==========
// Desktop slike (horizontalne): public_html/images/hero/
// Mobilne slike (vertikalne): public_html/images/hero-mobile/
// Galerija: public_html/images/galerija/

const HERO_SLIKE_DESKTOP = [
  { url: "/images/hero/1.jpg", position: "center" },
  { url: "/images/hero/2.jpg", position: "center" },
  { url: "/images/hero/3.jpg", position: "center" },
  { url: "/images/hero/4.jpg", position: "center" },
  { url: "/images/hero/5.jpg", position: "center" }
];

// Mobilne slike - VERTIKALNE (portrait)
const HERO_SLIKE_MOBILE = [
  { url: "/images/hero-mobile/1.jpg", position: "center" },
  { url: "/images/hero-mobile/2.jpg", position: "center" },
  { url: "/images/hero-mobile/3.jpg", position: "center" },
  { url: "/images/hero-mobile/4.jpg", position: "center" },
  { url: "/images/hero-mobile/5.jpg", position: "center" }
];

const GALERIJA_SLIKE = [
  { url: "/images/galerija/1.jpg", position: "center" },
  { url: "/images/galerija/2.jpg", position: "center" },
  { url: "/images/galerija/3.jpg", position: "center" },
  { url: "/images/galerija/4.jpg", position: "center" },
  { url: "/images/galerija/5.jpg", position: "center" },
  { url: "/images/galerija/6.jpg", position: "center" }
];

// ========== PREVODI / TRANSLATIONS ==========
const TRANSLATIONS = {
  sr: {
    nav: { menu: 'Jelovnik', gallery: 'Galerija', location: 'Lokacija', reservation: 'Rezervacija' },
    hero: { 
      subtitle: 'Riblji Restoran',
      title: 'Čarda Mačak',
      description: 'Tradicionalni riblji specijaliteti na obali Dunava',
      reserveBtn: 'Rezerviši sto',
      menuBtn: 'Pogledaj jelovnik',
      scroll: 'Skroluj'
    },
    menu: {
      title: 'Naš Jelovnik',
      subtitle: 'Specijaliteti',
      description: 'Sveža riba iz Dunava, tradicionalni recepti i ukusi koji se pamte generacijama',
      categories: {
        ribljiSpecijaliteti: { title: 'Riblji Specijaliteti', subtitle: 'čorbe i paprikaš' },
        riba: { title: 'Sveža Riba', subtitle: 'pečena i pohovana' },
        rostilj: { title: 'Roštilj', subtitle: 'sa žara' },
        salateIPrilozi: { title: 'Salate & Prilozi', subtitle: '' },
        deserti: { title: 'Deserti', subtitle: 'slatki završetak' }
      },
      note: 'Služimo uz domaću testeninu'
    },
    features: {
      liveMusic: { title: 'Tamburaši vikendom', desc: 'Živa muzika petkom i subotom' },
      delivery: { title: 'Dostava ribe', desc: 'Poručite svežu ribu na vašu adresu' },
      freshFish: { title: 'Sveža riba', desc: 'Direktno iz Dunava svakodnevno' }
    },
    deliverySection: {
      badge: 'Dostava',
      title: 'Poručite Svežu Ribu',
      description: 'Dostavljamo svežu ribu i naše specijalitete na vašu adresu. Pozovite nas i uživajte u ukusima Čarde Mačak kod kuće.'
    },
    gallery: {
      title: 'Galerija',
      subtitle: 'Atmosfera',
      description: 'Pogledajte ambijent i specijalitete našeg restorana'
    },
    location: {
      subtitle: 'Gde se nalazimo',
      title: 'Nađite Nas',
      description: 'Posetite nas na adresi Kamenjar 387, Novi Sad',
      address: 'Adresa',
      phone: 'Telefon',
      hours: 'Radno vreme',
      directions: 'Otvori u Google Maps'
    },
    footer: {
      description: 'Tradicionalni riblji restoran u Novom Sadu. Sveža riba, domaća kuhinja i nezaboravan ambijent na obali Dunava.',
      liveMusicNote: 'Tamburaši petkom i subotom',
      contact: 'Kontakt',
      followUs: 'Pratite Nas',
      reserveNow: 'Rezerviši odmah',
      orDelivery: 'ili poruči dostavu',
      deliveryNote: 'Dostava na adresu',
      rights: 'Sva prava zadržana',
      workingDays: 'Svakog dana'
    },
    infoBar: {
      workingDays: 'Svakog dana'
    }
  },
  en: {
    nav: { menu: 'Menu', gallery: 'Gallery', location: 'Location', reservation: 'Reservation' },
    hero: { 
      subtitle: 'Fish Restaurant',
      title: 'Čarda Mačak',
      description: 'Traditional fish specialties on the banks of the Danube',
      reserveBtn: 'Reserve a table',
      menuBtn: 'View menu',
      scroll: 'Scroll'
    },
    menu: {
      title: 'Our Menu',
      subtitle: 'Specialties',
      description: 'Fresh fish from the Danube, traditional recipes and flavors remembered for generations',
      categories: {
        ribljiSpecijaliteti: { title: 'Fish Specialties', subtitle: 'soups and stews' },
        riba: { title: 'Fresh Fish', subtitle: 'grilled and fried' },
        rostilj: { title: 'Grill', subtitle: 'from the grill' },
        salateIPrilozi: { title: 'Salads & Sides', subtitle: '' },
        deserti: { title: 'Desserts', subtitle: 'sweet ending' }
      },
      note: 'Served with homemade pasta'
    },
    features: {
      liveMusic: { title: 'Live music on weekends', desc: 'Live music every Friday and Saturday' },
      delivery: { title: 'Fish delivery', desc: 'Order fresh fish to your address' },
      freshFish: { title: 'Fresh fish', desc: 'Directly from the Danube daily' }
    },
    deliverySection: {
      badge: 'Delivery',
      title: 'Order Fresh Fish',
      description: 'We deliver fresh fish and our specialties to your address. Call us and enjoy the tastes of Čarda Mačak at home.'
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Atmosphere',
      description: 'See the atmosphere and specialties of our restaurant'
    },
    location: {
      subtitle: 'Where we are',
      title: 'Find Us',
      description: 'Visit us at Kamenjar 387, Novi Sad',
      address: 'Address',
      phone: 'Phone',
      hours: 'Working hours',
      directions: 'Open in Google Maps'
    },
    footer: {
      description: 'Traditional fish restaurant in Novi Sad. Fresh fish, homemade cuisine and unforgettable ambiance on the banks of the Danube.',
      liveMusicNote: 'Live music on Fridays and Saturdays',
      contact: 'Contact',
      followUs: 'Follow Us',
      reserveNow: 'Reserve now',
      orDelivery: 'or order delivery',
      deliveryNote: 'Delivery available',
      rights: 'All rights reserved',
      workingDays: 'Every day'
    },
    infoBar: {
      workingDays: 'Every day'
    }
  }
};

// ========== OVDE MENJATE MENI I CENE ==========
const MENI = {
  ribljiSpecijaliteti: {
    title: "Riblji Specijaliteti",
    subtitle: "čorbe i paprikaš",
    icon: "soup",
    items: [
      { name: "Riblja čorba", description: "Tradicionalni recept", price: 720 },
      { name: "Riblji paprikaš bez kosti", description: "Bogat ukus", price: 1120 }
    ]
  },
  riba: {
    title: "Sveža Riba",
    subtitle: "pečena i pohovana",
    icon: "fish",
    items: [
      { name: "Som", weight: "350g", price: 1350 },
      { name: "Smuđ", weight: "350g", price: 1390 },
      { name: "Smuđ file", weight: "300g", price: 1680 },
      { name: "Smuđ Orli", weight: "350g", price: 1690 },
      { name: "Kečiga", weight: "350g", price: 1680 },
      { name: "Pastrmka", weight: "350g", price: 1290 },
      { name: "Štuka", weight: "350g", price: 1100 },
      { name: "Šaran", weight: "350g", price: 1190 },
      { name: "Šaran dimljeni", weight: "350g", price: 1390 },
      { name: "Karaš, melez", weight: "350g", price: 790 },
      { name: "Jesetra", weight: "350g", price: 590 },
      { name: "Girice", weight: "300g", price: 590 },
      { name: "Dimljena pastrmka fileti", weight: "300g", price: 1590 }
    ]
  },
  rostilj: {
    title: "Roštilj",
    subtitle: "sa žara",
    icon: "flame",
    items: [
      { name: "Ćevapi", weight: "250g", price: 890 },
      { name: "Ražnjići", weight: "250g", price: 890 },
      { name: "Pljeskavica", weight: "250g", price: 890 },
      { name: "Roštilj kobasica", weight: "250g", price: 890 },
      { name: "Pileće belo meso", weight: "250g", price: 990 },
      { name: "Mešano meso", weight: "700g", price: 1790 },
      { name: "Karađorđeva šnicla", weight: "400g", price: 1290 },
      { name: "Bečka šnicla", weight: "300g", price: 1090 }
    ]
  },
  salateIPrilozi: {
    title: "Salate & Prilozi",
    subtitle: null,
    icon: "salad",
    items: [
      { name: "Sezonska salata", price: 320 },
      { name: "Šopska salata", price: 350 },
      { name: "Srpska salata", price: 350 },
      { name: "Bašta salata", price: 350 },
      { name: "Ljuta zelena paprika", weight: "kom", price: 180 },
      { name: "Pomfrit", weight: "250g", price: 280 },
      { name: "Hleb", weight: "parče", price: 80 }
    ]
  },
  deserti: {
    title: "Deserti",
    subtitle: "slatki završetak",
    icon: "cake",
    items: [
      { name: "Gomboce sa šljivama", price: 350 },
      { name: "Banana split", price: 380 },
      { name: "Šnenokle", price: 380 },
      { name: "Rezanci sa makom", price: 380 },
      { name: "Štrudla", subtitle: "mak, jabuka ili orah", price: 380 }
    ]
  }
};
// ============================================

// Menu Item Component with dots
const MenuItem = ({ item }) => (
  <div className="menu-item">
    <div className="menu-item-info">
      <span className="menu-item-name">{item.name}</span>
      {item.weight && <span className="menu-item-weight">({item.weight})</span>}
      {item.subtitle && <span className="menu-item-weight">({item.subtitle})</span>}
      {item.description && <span className="menu-item-weight">- {item.description}</span>}
    </div>
    <div className="menu-item-dots"></div>
    <span className="menu-item-price">{item.price} RSD</span>
  </div>
);

const CardaMacakLanding = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [lang, setLang] = useState('sr'); // 'sr' or 'en'
  
  // Get translations
  const t = TRANSLATIONS[lang];
  
  // Detect mobile
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Koristi razlicite slike za desktop i mobile
  const heroImages = isMobile ? HERO_SLIKE_MOBILE : HERO_SLIKE_DESKTOP;
  const galleryImages = GALERIJA_SLIKE;
  const menu = MENI;

  // Auto-rotate hero images
  useEffect(() => {
    if (heroImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  // Handle scroll for navbar - hide on scroll down, show on scroll up
  const [lastScrollY, setLastScrollY] = useState(0);
  const [hideNav, setHideNav] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrolled(currentScrollY > 50);
      
      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setHideNav(true);
      } else {
        setHideNav(false);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };
  
  const toggleLang = () => setLang(lang === 'sr' ? 'en' : 'sr');

  const getMenuIcon = (iconName) => {
    const iconProps = { className: "w-6 h-6" };
    switch (iconName) {
      case 'fish': return <Fish {...iconProps} />;
      case 'flame': return <Flame {...iconProps} />;
      case 'salad': return <Salad {...iconProps} />;
      case 'cake': return <Cake {...iconProps} />;
      case 'soup': return <Fish {...iconProps} />;
      default: return <Fish {...iconProps} />;
    }
  };

  const getFeatureIcon = (iconName) => {
    const iconProps = { className: "w-8 h-8" };
    switch (iconName) {
      case 'music': return <Music {...iconProps} />;
      case 'truck': return <Truck {...iconProps} />;
      case 'fish': return <Fish {...iconProps} />;
      default: return <Fish {...iconProps} />;
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f0e8]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-[#0a1628] shadow-lg' 
          : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Mobile Header - Logo centered, bigger */}
          <div className="md:hidden flex flex-col items-center pt-4 pb-2">
            <div className="w-full flex items-center justify-between mb-2">
              <button 
                onClick={toggleLang}
                className="flex items-center gap-1 px-2 py-1 rounded border border-white/30 text-white/80 text-xs"
              >
                {lang === 'sr' ? 'EN' : 'SR'}
              </button>
              
              <button 
                className="p-2 text-white"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
            
            <button onClick={() => scrollToSection('hero')} className="flex flex-col items-center">
              <img 
                src={restaurantInfo.logo} 
                alt="Čarda Mačak" 
                className="h-28 w-28 object-contain"
              />
              <span className="font-serif text-lg font-semibold text-white tracking-wide mt-1">
                Čarda Mačak
              </span>
              <p className="text-[#c9a962] text-xs tracking-widest uppercase">{t.hero.subtitle}</p>
            </button>
          </div>

          {/* Desktop Header */}
          <div className="hidden md:flex items-center justify-between h-20">
            <button onClick={() => scrollToSection('hero')} className="flex items-center gap-4">
              <img 
                src={restaurantInfo.logo} 
                alt="Čarda Mačak" 
                className="h-16 w-16 object-contain"
              />
              <div>
                <span className="font-serif text-xl font-semibold text-white tracking-wide">
                  Čarda Mačak
                </span>
                <p className="text-[#c9a962] text-xs tracking-widest uppercase">{t.hero.subtitle}</p>
              </div>
            </button>

            {/* Desktop Nav */}
            <div className="flex items-center gap-8">
              <button onClick={() => scrollToSection('jelovnik')} className="nav-link text-white/90 text-sm tracking-wide">
                {t.nav.menu}
              </button>
              <button onClick={() => scrollToSection('galerija')} className="nav-link text-white/90 text-sm tracking-wide">
                {t.nav.gallery}
              </button>
              <button onClick={() => scrollToSection('lokacija')} className="nav-link text-white/90 text-sm tracking-wide">
                {t.nav.location}
              </button>
              
              {/* Language Toggle */}
              <button 
                onClick={toggleLang}
                className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/30 text-white/80 hover:bg-white/10 transition-all text-sm"
              >
                <Globe className="w-4 h-4" />
                {lang === 'sr' ? 'EN' : 'SR'}
              </button>
              
              <a 
                href={`tel:${restaurantInfo.phone}`}
                className="btn-primary"
              >
                <Phone className="w-4 h-4" />
                {t.nav.reservation}
              </a>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden absolute top-full left-0 right-0 bg-[#0a1628] shadow-xl py-6 px-6 border-t border-white/10">
              <div className="flex flex-col gap-4">
                <button onClick={() => scrollToSection('jelovnik')} className="text-white font-medium text-left py-3 border-b border-white/10 hover:text-[#c9a962] transition-colors">
                  {t.nav.menu}
                </button>
                <button onClick={() => scrollToSection('galerija')} className="text-white font-medium text-left py-3 border-b border-white/10 hover:text-[#c9a962] transition-colors">
                  {t.nav.gallery}
                </button>
                <button onClick={() => scrollToSection('lokacija')} className="text-white font-medium text-left py-3 border-b border-white/10 hover:text-[#c9a962] transition-colors">
                  {t.nav.location}
                </button>
                <a 
                  href={`tel:${restaurantInfo.phone}`}
                  className="btn-primary w-full mt-2"
                >
                  <Phone className="w-4 h-4" />
                  {t.nav.reservation}
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section - Desktop: side by side, Mobile: fullscreen overlay */}
      <section id="hero" className="min-h-screen bg-[#0a1628]">
        {/* Mobile Layout - Fullscreen image with overlay */}
        <div className="lg:hidden relative min-h-screen overflow-hidden">
          {/* Background Images */}
          {heroImages.map((image, index) => (
            <div 
              key={image.id || index} 
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image.url} 
                alt={`Čarda Mačak - Riblji restoran ${index + 1}`}
                className="w-full h-full object-cover"
                style={{ objectPosition: image.position || 'center' }}
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
              />
            </div>
          ))}
          
          {/* Gradient overlay - stronger at top */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628] via-[#0a1628]/20 to-[#0a1628]/70" />
          
          {/* Content - Only buttons at bottom */}
          <div className="relative z-10 min-h-screen flex flex-col justify-end pb-32 px-6">
            {/* Buttons */}
            <div className="flex flex-col gap-3 w-full max-w-[280px] mx-auto">
              <a 
                href={`tel:${restaurantInfo.phone}`} 
                className="flex items-center justify-center gap-3 bg-[#c9a962] text-[#0a1628] py-4 px-6 rounded-lg font-semibold text-sm tracking-wide uppercase transition-all active:scale-95"
              >
                <Phone className="w-4 h-4" />
                {t.hero.reserveBtn}
              </a>
              <button 
                onClick={() => scrollToSection('jelovnik')}
                className="flex items-center justify-center gap-2 border border-white/30 text-white py-3 px-6 rounded-lg font-medium text-sm tracking-wide uppercase transition-all active:scale-95 active:bg-white/10"
              >
                {t.hero.menuBtn}
              </button>
            </div>
            
            {/* Slide Indicators */}
            <div className="flex justify-center mt-4">
              {heroImages.length > 0 && (
                <div className="flex gap-2">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`rounded-full transition-all duration-500 ${
                        index === currentSlide 
                          ? 'bg-[#c9a962] w-8 h-2' 
                          : 'bg-white/30 w-2 h-2'
                      }`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Desktop Layout - Full width image with gradient overlay */}
        <div className="hidden lg:flex min-h-screen relative">
          {/* Full background image */}
          <div className="absolute inset-0">
            {heroImages.map((image, index) => (
              <div 
                key={image.id || index} 
                className={`absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img 
                  src={image.url} 
                  alt={`Čarda Mačak ${index + 1}`}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: image.position || 'center' }}
                />
              </div>
            ))}
            {/* Gradient overlay from left */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628] via-[#0a1628]/80 to-transparent w-3/5"></div>
          </div>

          {/* Text Content - over gradient */}
          <div className="relative z-10 w-1/2 flex items-center p-12 xl:p-20">
            <div className="max-w-lg">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-16 h-px bg-gradient-to-r from-transparent to-[#c9a962]"></div>
                <span className="text-[#c9a962] text-sm tracking-[0.3em] uppercase font-medium">{t.hero.subtitle}</span>
              </div>
              
              <img 
                src={restaurantInfo.logo} 
                alt="Čarda Mačak Logo" 
                className="w-36 h-36 mb-8 object-contain drop-shadow-2xl"
              />
              
              <h1 className="font-serif text-5xl xl:text-6xl font-bold text-white mb-6 tracking-wide leading-tight">
                {t.hero.title}
              </h1>
              
              <p className="text-white/70 text-xl font-light mb-10 leading-relaxed">
                {t.hero.description}
              </p>
              
              <div className="flex gap-4 mb-12">
                <a href={`tel:${restaurantInfo.phone}`} className="cta-button">
                  <Phone className="w-5 h-5" />
                  {t.hero.reserveBtn}
                </a>
                <button 
                  onClick={() => scrollToSection('jelovnik')}
                  className="btn-secondary"
                >
                  {t.hero.menuBtn}
                </button>
              </div>

              {/* Desktop Slide Indicators */}
              {heroImages.length > 0 && (
                <div className="flex gap-3">
                  {heroImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`h-1.5 rounded-full transition-all duration-500 ${
                        index === currentSlide 
                          ? 'bg-[#c9a962] w-10' 
                          : 'bg-white/30 w-6 hover:bg-white/50'
                      }`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator hidden sm:block">
          <div className="flex flex-col items-center gap-2">
            <span className="text-white/60 text-xs tracking-widest uppercase">{t.hero.scroll}</span>
            <ChevronDown className="w-6 h-6 text-[#c9a962]" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="bg-[#0a1628] py-10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Live Music */}
            <div className="flex items-center gap-5 p-6 rounded-xl bg-white/5 border border-white/10 hover:border-[#c9a962]/30 transition-all duration-300 hover:transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a88b45] flex items-center justify-center flex-shrink-0">
                {getFeatureIcon('music')}
              </div>
              <div>
                <h3 className="text-white font-semibold text-lg mb-1">{t.features.liveMusic.title}</h3>
                <p className="text-white/60 text-sm">{t.features.liveMusic.desc}</p>
              </div>
            </div>
            {/* Delivery */}
            <div className="flex items-center gap-5 p-6 rounded-xl bg-white/5 border border-white/10 hover:border-[#c9a962]/30 transition-all duration-300 hover:transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a88b45] flex items-center justify-center flex-shrink-0">
                {getFeatureIcon('truck')}
              </div>
              <div>
                <h3 className="text-white font-semibold text-lg mb-1">{t.features.delivery.title}</h3>
                <p className="text-white/60 text-sm">{t.features.delivery.desc}</p>
              </div>
            </div>
            {/* Fresh Fish */}
            <div className="flex items-center gap-5 p-6 rounded-xl bg-white/5 border border-white/10 hover:border-[#c9a962]/30 transition-all duration-300 hover:transform hover:-translate-y-1">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#c9a962] to-[#a88b45] flex items-center justify-center flex-shrink-0">
                {getFeatureIcon('fish')}
              </div>
              <div>
                <h3 className="text-white font-semibold text-lg mb-1">{t.features.freshFish.title}</h3>
                <p className="text-white/60 text-sm">{t.features.freshFish.desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info Bar */}
      <section className="bg-[#c9a962] py-4">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 text-sm">
            <div className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-[#0a1628]" />
              <span className="text-[#0a1628] font-medium">{restaurantInfo.address}</span>
            </div>
            <div className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-[#0a1628]" />
              <span className="text-[#0a1628] font-medium">{restaurantInfo.workingHours} • {t.infoBar.workingDays}</span>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#0a1628]" />
              <a href={`tel:${restaurantInfo.phone}`} className="text-[#0a1628] font-medium hover:underline">
                {restaurantInfo.phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section id="jelovnik" className="py-12 md:py-16 section-light">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="text-[#c9a962] text-sm tracking-[0.3em] uppercase font-medium">{t.menu.subtitle}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#0a1628] mt-4 mb-4">
              {t.menu.title}
            </h2>
            <div className="decorative-line"></div>
            <p className="text-[#8b9aab] text-lg max-w-2xl mx-auto">
              {t.menu.description}
            </p>
          </div>

          {menu ? (
            <>
              {/* First row - Riblji specijaliteti + Sveža riba */}
              <div className="grid lg:grid-cols-3 gap-8 mb-8">
                {/* Riblji Specijaliteti */}
                {menu.ribljiSpecijaliteti && (
                  <div className="menu-card lg:col-span-1">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="menu-category-icon">
                        {getMenuIcon(menu.ribljiSpecijaliteti.icon)}
                      </div>
                      <div>
                        <h3 className="font-serif text-2xl font-bold text-[#0a1628]">
                          {t.menu.categories.ribljiSpecijaliteti.title}
                        </h3>
                        <p className="text-[#8b9aab] text-sm mt-1">{t.menu.categories.ribljiSpecijaliteti.subtitle}</p>
                      </div>
                    </div>
                    <div>
                      {menu.ribljiSpecijaliteti.items.map((item, index) => (
                        <MenuItem key={item.id || index} item={item} />
                      ))}
                    </div>
                    <div className="mt-6 p-4 bg-gradient-to-r from-[#0a1628] to-[#1a2d4a] rounded-lg">
                      <p className="text-[#c9a962] text-sm font-medium text-center">
                        {t.menu.note}
                      </p>
                    </div>
                  </div>
                )}

                {/* Sveža Riba */}
                {menu.riba && (
                  <div className="menu-card lg:col-span-2">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="menu-category-icon">
                        {getMenuIcon(menu.riba.icon)}
                      </div>
                      <div>
                        <h3 className="font-serif text-2xl font-bold text-[#0a1628]">
                          {t.menu.categories.riba.title}
                        </h3>
                        <p className="text-[#8b9aab] text-sm mt-1">{t.menu.categories.riba.subtitle}</p>
                      </div>
                    </div>
                    <div className="grid sm:grid-cols-2 gap-x-8">
                      {menu.riba.items.map((item, index) => (
                        <MenuItem key={item.id || index} item={item} />
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Second row - Roštilj, Salate, Deserti */}
              <div className="grid md:grid-cols-3 gap-8">
                {/* Roštilj */}
                {menu.rostilj && (
                  <div className="menu-card">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="menu-category-icon">
                        {getMenuIcon(menu.rostilj.icon)}
                      </div>
                      <div>
                        <h3 className="font-serif text-2xl font-bold text-[#0a1628]">
                          {t.menu.categories.rostilj.title}
                        </h3>
                        <p className="text-[#8b9aab] text-sm mt-1">{t.menu.categories.rostilj.subtitle}</p>
                      </div>
                    </div>
                    <div>
                      {menu.rostilj.items.map((item, index) => (
                        <MenuItem key={item.id || index} item={item} />
                      ))}
                    </div>
                  </div>
                )}

                {/* Salate & Prilozi */}
                {menu.salateIPrilozi && (
                  <div className="menu-card">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="menu-category-icon">
                        {getMenuIcon(menu.salateIPrilozi.icon)}
                      </div>
                      <div>
                        <h3 className="font-serif text-2xl font-bold text-[#0a1628]">
                          {t.menu.categories.salateIPrilozi.title}
                        </h3>
                      </div>
                    </div>
                    <div>
                      {menu.salateIPrilozi.items.map((item, index) => (
                        <MenuItem key={item.id || index} item={item} />
                      ))}
                    </div>
                  </div>
                )}

                {/* Deserti */}
                {menu.deserti && (
                  <div className="menu-card">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="menu-category-icon">
                        {getMenuIcon(menu.deserti.icon)}
                      </div>
                      <div>
                        <h3 className="font-serif text-2xl font-bold text-[#0a1628]">
                          {t.menu.categories.deserti.title}
                        </h3>
                        <p className="text-[#8b9aab] text-sm mt-1">{t.menu.categories.deserti.subtitle}</p>
                      </div>
                    </div>
                    <div>
                      {menu.deserti.items.map((item, index) => (
                        <MenuItem key={item.id || index} item={item} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="text-center py-12 text-[#8b9aab]">
              {lang === 'sr' ? 'Učitavanje jelovnika...' : 'Loading menu...'}
            </div>
          )}
        </div>
      </section>

      {/* Delivery CTA Section */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-gradient-to-r from-[#0a1628] to-[#1a2d4a] rounded-2xl p-10 md:p-16 relative overflow-hidden">
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#c9a962] rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#c9a962] rounded-full blur-3xl"></div>
            </div>
            
            <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
                  <Truck className="w-8 h-8 text-[#c9a962]" />
                  <span className="text-[#c9a962] text-sm tracking-[0.2em] uppercase font-medium">{t.deliverySection.badge}</span>
                </div>
                <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
                  {t.deliverySection.title}
                </h3>
                <p className="text-white/70 text-lg mb-6 md:mb-0">
                  {t.deliverySection.description}
                </p>
              </div>
              <div className="flex-shrink-0">
                <a 
                  href={`tel:${restaurantInfo.phone}`}
                  className="cta-button text-lg whitespace-nowrap"
                >
                  <Phone className="w-5 h-5" />
                  {restaurantInfo.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="galerija" className="py-12 md:py-16 section-light">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-10">
            <span className="text-[#c9a962] text-sm tracking-[0.3em] uppercase font-medium">{t.gallery.subtitle}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#0a1628] mt-4 mb-4">
              {t.gallery.title}
            </h2>
            <div className="decorative-line"></div>
            <p className="text-[#8b9aab] text-lg max-w-2xl mx-auto">
              {t.gallery.description}
            </p>
          </div>

          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div key={image.id || index} className="gallery-item">
                <img 
                  src={image.url} 
                  alt={`Čarda Mačak galerija - Sveža riba ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                  style={{ objectPosition: image.position || 'center' }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section id="lokacija" className="py-12 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-8">
            <span className="text-[#c9a962] text-sm tracking-[0.3em] uppercase font-medium">{t.location.subtitle}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#0a1628] mt-4 mb-4">
              {t.location.title}
            </h2>
            <div className="decorative-line"></div>
            <p className="text-[#8b9aab] text-lg max-w-2xl mx-auto">
              {t.location.description}
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 rounded-2xl overflow-hidden shadow-xl h-[400px] lg:h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2806.1234567890123!2d19.83!3d45.267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b100000000000%3A0x0!2sKamenjar%20387%2C%20Novi%20Sad!5e0!3m2!1sen!2srs!4v1234567890123"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Čarda Mačak lokacija"
              ></iframe>
            </div>

            <div className="bg-gradient-to-br from-[#0a1628] to-[#1a2d4a] rounded-2xl p-8 text-white">
              <img 
                src={restaurantInfo.logo} 
                alt="Čarda Mačak" 
                className="h-16 w-16 object-contain mb-6"
              />
              <h3 className="font-serif text-2xl font-bold mb-6">Čarda Mačak</h3>
              
              <div className="space-y-5 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <div>
                    <p className="text-white/60 text-sm mb-1">{t.location.address}</p>
                    <p className="text-white">{restaurantInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <div>
                    <p className="text-white/60 text-sm mb-1">{t.location.phone}</p>
                    <a href={`tel:${restaurantInfo.phone}`} className="text-white hover:text-[#c9a962] transition-colors">
                      {restaurantInfo.phone}
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <div>
                    <p className="text-white/60 text-sm mb-1">{t.location.hours}</p>
                    <p className="text-white">{restaurantInfo.workingHours}</p>
                    <p className="text-white/60 text-sm">{t.footer.workingDays}</p>
                  </div>
                </div>
              </div>

              <a 
                href={restaurantInfo.googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary w-full"
              >
                <Navigation className="w-4 h-4" />
                {t.location.directions}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <section className="footer text-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
            <div>
              <img 
                src={restaurantInfo.logo} 
                alt="Čarda Mačak" 
                className="h-20 w-20 object-contain mb-6"
              />
              <h3 className="font-serif text-2xl font-bold mb-2">Čarda Mačak</h3>
              <p className="text-[#c9a962] text-sm tracking-widest uppercase mb-4">{t.hero.subtitle}</p>
              <p className="text-white/60 leading-relaxed mb-6">
                {t.footer.description}
              </p>
              <div className="flex items-center gap-3 text-[#c9a962]">
                <Music className="w-5 h-5" />
                <span className="text-sm font-medium">{t.footer.liveMusicNote}</span>
              </div>
            </div>

            <div>
              <h4 className="font-serif text-xl font-bold mb-8">{t.footer.contact}</h4>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <p className="text-white/90">{restaurantInfo.address}</p>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <a href={`tel:${restaurantInfo.phone}`} className="text-white/90 hover:text-[#c9a962] transition-colors">
                    {restaurantInfo.phone}
                  </a>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <span className="text-white/90">{restaurantInfo.workingHours}</span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                    <Truck className="w-4 h-4 text-[#c9a962]" />
                  </div>
                  <span className="text-white/90">{t.footer.deliveryNote}</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-serif text-xl font-bold mb-8">{t.footer.followUs}</h4>
              <div className="flex gap-4 mb-10">
                <a 
                  href={restaurantInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <Instagram className="w-5 h-5 text-white" />
                </a>
                <a 
                  href={restaurantInfo.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <Facebook className="w-5 h-5 text-white" />
                </a>
              </div>
              <a 
                href={`tel:${restaurantInfo.phone}`}
                className="btn-primary w-full mb-4"
              >
                <Phone className="w-4 h-4" />
                {t.footer.reserveNow}
              </a>
              <p className="text-white/40 text-sm text-center">
                {t.footer.orDelivery}
              </p>
            </div>
          </div>

          <div className="border-t border-white/10 mt-16 pt-8 text-center text-white/40 text-sm">
            <p>© {new Date().getFullYear()} Čarda Mačak. {t.footer.rights}.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CardaMacakLanding;
